import $ from "jquery";
import Swiper from "../../sliders/swiper-base.js";

/** Matches `until($mobile)` in SCSS ($mobile = 790px → max-width 789px). */
var POSTGRID_MOBILE_SLIDER_MQ = "(max-width: 789px)";

function readDataAttr($el, name) {
    var v = $el.attr("data-" + name);
    if (v === undefined || v === "") {
        return null;
    }
    return v;
}

function initOrDestroyPostgridMobileSliders() {
    var mq = window.matchMedia(POSTGRID_MOBILE_SLIDER_MQ);

    $(".postgrid__mobile-slider-track.slider-init").each(function () {
        var el = this;
        var $track = $(el);
        var sliderRoot = $track.closest(".postgrid__slider-container");
        var slideId = sliderRoot.attr("id");
        if (!slideId) {
            return;
        }

        if (mq.matches) {
            if (el.swiper) {
                return;
            }

            var next = "#" + slideId + " .swiper__next";
            var prev = "#" + slideId + " .swiper__prev";
            var slidesPerViewMobile =
                readDataAttr($track, "slidesperview_mobile") || "1.2";
            var spaceMobile = parseInt(
                readDataAttr($track, "space_mobile") || "10",
                10
            );
            var slideIndexMobile = parseInt(
                readDataAttr($track, "slide_index_mobile") || "0",
                10
            );

            var spv = parseFloat(slidesPerViewMobile);
            if (!isFinite(spv)) {
                spv = 1.2;
            }

            new Swiper(el, {
                loop: false,
                slidesPerView: spv,
                spaceBetween: spaceMobile,
                initialSlide: slideIndexMobile,
                scrollbar: {
                    el: $track.find(".swiper-scrollbar").get(0),
                    hide: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
            });
        } else if (el.swiper) {
            el.swiper.destroy(true, true);
        }
    });
}

jQuery(document).ready(function ($) {
    function applyPostgridMasonry($grid) {
        if (!$grid.length || !$grid.closest(".postgrid--alternate-no-image").length) {
            return;
        }

        var gridStyles = window.getComputedStyle($grid[0]);
        var rowSize = parseFloat(gridStyles.getPropertyValue("grid-auto-rows")) || 10;
        var gapSize = parseFloat(gridStyles.getPropertyValue("row-gap")) || 0;

        var $items = $grid.find("> .single_card");
        if (!$items.length) {
            $items = $grid.find("> .swiper-slide > .single_card");
        }

        $items.each(function () {
            var $item = $(this);
            var itemHeight = $item.outerHeight();
            var span = Math.max(1, Math.ceil((itemHeight + gapSize) / rowSize));
            $item.css("grid-row-end", "span " + span);
        });
    }

    function refreshAllPostgridMasonry() {
        $(
            ".postgrid--alternate-no-image .grid-1, .postgrid--alternate-no-image .grid-2, .postgrid--alternate-no-image .grid-3, .postgrid--alternate-no-image .grid-4, .postgrid--alternate-no-image .grid-5, .postgrid--alternate-no-image .grid-6"
        ).each(function () {
            applyPostgridMasonry($(this));
        });
    }

    refreshAllPostgridMasonry();

    $(window).on("load resize", function () {
        refreshAllPostgridMasonry();
    });

    $(".postgrid--alternate-no-image img").on("load", function () {
        refreshAllPostgridMasonry();
    });

    function onMobileSliderLayoutChange() {
        initOrDestroyPostgridMobileSliders();
        setTimeout(refreshAllPostgridMasonry, 50);
    }

    setTimeout(onMobileSliderLayoutChange, 100);

    if (window.matchMedia) {
        var mqSlider = window.matchMedia(POSTGRID_MOBILE_SLIDER_MQ);
        if (mqSlider.addEventListener) {
            mqSlider.addEventListener("change", onMobileSliderLayoutChange);
        } else {
            mqSlider.addListener(onMobileSliderLayoutChange);
        }
    }

    $(window).on("resize", function () {
        onMobileSliderLayoutChange();
    });

    $(".loadmore_button").on("click", function () {
        var load_number = 6;
        var fade_duration = 300;

        var postgrid = $(this).closest(".postgrid");

        var card_total = postgrid.find(".card-con").length;
        var loadmore = postgrid.find(".loadmore").length;
        var visible_cards = card_total - loadmore;

        var loadmore_elements = postgrid.find(".loadmore").slice(0, load_number);

        loadmore_elements.each(function (index) {
            var element = $(this);
            setTimeout(function () {
                element
                    .css({
                        display: "flex",
                        opacity: 0,
                    })
                    .fadeTo(fade_duration, 1)
                    .removeClass("loadmore");
            }, index * 150);
        });

        if (visible_cards + load_number >= card_total) {
            $(this).fadeOut();
        }

        setTimeout(function () {
            refreshAllPostgridMasonry();
            onMobileSliderLayoutChange();
        }, load_number * 150 + fade_duration + 50);
    });
});
